import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { GlassCard, WalletCard, useAlert } from '../../components';
import { getUserProducts, getActiveAnnouncements } from '../../services/firestoreService';
import { formatCurrency, getGreeting } from '../../utils/helpers';
import './HomeScreen.css';

export const HomeScreen = () => {
    const navigate = useNavigate();
    const { userData } = useAuth();
    const alert = useAlert();
    const [userProducts, setUserProducts] = useState([]);
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const [products, announcements] = await Promise.all([
                getUserProducts(),
                getActiveAnnouncements(),
            ]);
            setUserProducts(products);
            setAnnouncements(announcements.slice(0, 3));
        } catch (error) {
            console.error('Error loading data:', error);
        } finally {
            setLoading(false);
        }
    };

    const quickActions = [
        { icon: 'shopping_cart', label: 'Products', route: '/products', color: '#D4AF37' },
        { icon: 'inventory_2', label: 'My Products', route: '/my-products', color: '#00C853' },
        { icon: 'history', label: 'History', route: '/transactions', color: '#3B82F6' },
        { icon: 'card_giftcard', label: 'Gift Code', route: '/gift-code', color: '#F59E0B' },
    ];

    const totalDailyIncome = userProducts.reduce((sum, p) => sum + (p.dailyIncome || 0), 0);

    return (
        <div className="home-screen">
            {/* Header */}
            <div className="home-header">
                <div className="greeting-section">
                    <p className="greeting-text">{getGreeting()},</p>
                    <h1 className="user-name">{userData?.displayName || 'User'}</h1>
                </div>
                <button className="notification-btn" onClick={() => navigate('/notifications')}>
                    <span className="material-icons">notifications</span>
                    {announcements.length > 0 && <span className="notification-badge"></span>}
                </button>
            </div>

            {/* Wallet Card */}
            <WalletCard
                rechargeBalance={userData?.rechargeBalance || 0}
                withdrawBalance={userData?.withdrawBalance || 0}
                onRecharge={() => navigate('/recharge')}
                onWithdraw={() => navigate('/withdraw')}
            />

            {/* Daily Stats Summary */}
            <div className="home-stats-compact">
                <div className="compact-stat">
                    <span className="compact-label">Daily Income</span>
                    <span className="compact-value">{formatCurrency(totalDailyIncome)}</span>
                </div>
                <div className="stat-divider"></div>
                <div className="compact-stat">
                    <span className="compact-label">Active Plans</span>
                    <span className="compact-value">{userProducts.length}</span>
                </div>
            </div>

            {/* Quick Actions Grid */}
            <div className="section">
                <div className="quick-actions-grid">
                    {quickActions.map((action, index) => (
                        <GlassCard
                            key={index}
                            className="action-item-card"
                            onClick={() => navigate(action.route)}
                        >
                            <div className="action-icon-wrapper" style={{ backgroundColor: `${action.color}15` }}>
                                <span className="material-icons" style={{ color: action.color }}>{action.icon}</span>
                            </div>
                            <span className="action-item-label">{action.label}</span>
                        </GlassCard>
                    ))}
                </div>
            </div>


        </div>
    );
};

export default HomeScreen;
